import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { kCoachingKeywordMaxLength } from '@euler/model/coaching';
import { Search } from 'lucide-react-native';
import { memo } from 'react';
import { TextInput, View } from 'react-native';

export const SearchBox = memo(
  ({
    value,
    onChange,
  }: {
    value: string;
    onChange: (value: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          height: rpx(44),
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(8),
          borderRadius: rpx(12),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: aiColors.card,
          paddingHorizontal: rpx(12),
        }}
      >
        <Search size={rpx(18)} color={aiColors.mutedForeground} />
        <TextInput
          value={value}
          onChangeText={onChange}
          placeholder="搜索案例、标签，如“换机油”“比价”"
          placeholderTextColor={aiColors.mutedForeground}
          accessibilityLabel="搜索案例"
          maxLength={kCoachingKeywordMaxLength}
          returnKeyType="search"
          style={{ flex: 1, fontSize: rpx(14), color: aiColors.foreground }}
        />
      </View>
    );
  },
);
